/** @format */

export function getPrefixedInternalNameLabel(row) {
  const name = row?.is_validated
    ? row.prefixed_internal_name || row.custom_internal_name || 'Non renseigné'
    : row?.prefixed_internal_name || 'Non renseigné';
  return row?.is_draft && !row?.is_validated ? `(brouillon) ${name}` : name;
}

export function formatApiError(err, fallback = 'Une erreur est survenue.') {
  const data = err?.response?.data;
  if (!data) {
    return err?.message || fallback;
  }
  if (typeof data === 'string') {
    return data;
  }
  if (Array.isArray(data)) {
    return data.join(', ');
  }
  if (data.detail) {
    return Array.isArray(data.detail)
      ? data.detail.join(', ')
      : String(data.detail);
  }
  const parts = [];
  const walk = (obj, prefix = '') => {
    Object.entries(obj).forEach(([key, val]) => {
      const path = prefix ? `${prefix}.${key}` : key;
      if (Array.isArray(val)) {
        parts.push(`${path}: ${val.join(', ')}`);
      } else if (val && typeof val === 'object') {
        walk(val, path);
      } else if (val) {
        parts.push(`${path}: ${val}`);
      }
    });
  };
  walk(data);
  return parts.join('; ') || fallback;
}
